import { produce } from 'immer';

import PropTypes, { arrayOf } from 'prop-types';
import { FIRST_AUTH_LOGIN, AUTH_LOGOUT } from '../actions';
import {
  REGION_PROVINCE_LIST_GET,
  SAVE_TEMP_TOKEN,
  UPDATE_USER_PICTURE,
  USER_INFO_GET,
} from '../actions/user';
import storage from '../../api/storage';
// import storage from '../../../utils/storage';

export const UserDataInterface = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  first_name: PropTypes.string.isRequired,
  last_name: PropTypes.string,
  username: PropTypes.string.isRequired,
  roles: arrayOf(PropTypes.string),
});

const initialState = {
  id: null,
  first_name: '',
  last_name: '',
  username: '',
  profile_pic: '',
  roles: [],
  isTutor: undefined,
  isCotutor: undefined,
  isSupervisor: undefined,
  isSubjectExpert: undefined,
  isAdmin: undefined,
  regionProvinceList: [],
  tempToken: null,
};

const userReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case AUTH_LOGOUT._SUCCESS: {
        draft = initialState;
        break;
      }

      case FIRST_AUTH_LOGIN._SUCCESS: {
        const { username, roles, otp_private_key } = action.data;
        draft.username = username;
        draft.roles = [...roles];
        storage.write('otp_private', otp_private_key, 'sessionStorage');
        break;
      }

      case USER_INFO_GET._SUCCESS: {
        const { response = {} } = action;
        draft = { ...state, ...response };
        draft.isTutor =
          response?.roles?.includes('tutor') ||
          response?.roles?.includes('supervisor');
        draft.isCotutor = response?.roles?.includes('cotutor');
        draft.isSupervisor = response?.roles?.includes('supervisor');
        draft.isSubjectExpert = response?.roles?.includes('subject_expert');
        draft.isAdmin = response?.roles?.includes('admin');
        break;
      }

      case UPDATE_USER_PICTURE: {
        draft.profile_pic = action?.url;
        break;
      }

      case REGION_PROVINCE_LIST_GET._SUCCESS: {
        draft.regionProvinceList = action.response;
        break;
      }

      case SAVE_TEMP_TOKEN: {
        draft.tempToken = action?.token;
        break;
      }

      default:
        return state;
    }
    return draft;
  });

export default userReducer;
